import api from "services/api";

export const getContractItemTypes = async () => {
  const response = await api.get("/Contract/item-types");
  return response.data.options || [];
};

const getLocations = async (endpoint, filters = {}) => {
  const rows = [];
  let pageNumber = 1;
  while (true) {
    const response = await api.get(endpoint, {
      params: { ...filters, pageSize: 1000, pageNumber },
    });
    const page = response.data.data || [];
    rows.push(...page);
    if (!page.length || rows.length >= (response.data.totalCount ?? rows.length)) break;
    pageNumber += 1;
  }
  return rows;
};

export const getContractProvinces = () => getLocations("/Province");
export const getContractCommunes = (provinceId) => getLocations("/Commune", { provinceId });

export const getContractItemSections = async (contractId) => {
  const response = await api.get(`/Contract/${contractId}/item-structure`);
  return response.data;
};

export const getContractImportConfiguration = async (contractId) => {
  const [contract, sections] = await Promise.all([api.get(`/Contract/${contractId}`), getContractItemSections(contractId)]);
  return { provinceId: contract.data.data.provinceId ?? null, sections };
};
